import { render, staticRenderFns } from "./warehouseGoodShow.vue?vue&type=template&id=27f16bb0&scoped=true&"
import script from "./warehouseGoodShow.vue?vue&type=script&lang=js&"
export * from "./warehouseGoodShow.vue?vue&type=script&lang=js&"
import style0 from "./warehouseGoodShow.vue?vue&type=style&index=0&id=27f16bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f16bb0",
  null
  
)

component.options.__file = "warehouseGoodShow.vue"
export default component.exports